import Select from '@/components/form/select';
import {DocumentInputField} from '@/engine/types';
import {useDocumentLocale} from '../../hooks/use-document-locale';
import {useSelectProps} from '../../hooks/use-select-props';
import {FieldProps} from '../../meta-field';

export const SelectField = (props: FieldProps<DocumentInputField>) => {
  const {_t} = useDocumentLocale();

  const {field, options, selectedOption, onChange, handleFocus, handleBlur} = useSelectProps(props);

  return (
    <Select
      id={field.id}
      required={field.required}
      data-testid={`${field.id}-control`}
      value={selectedOption?.value ?? ''}
      onChange={event => onChange(event.target.value)}
      onFocus={handleFocus}
      onBlur={handleBlur}
      isReadonly={field.readonly}
    >
      <option value="" style={{display: 'none'}}>
        {_t(field.placeholder)}
      </option>

      {options.map(option => (
        <option data-testid={`${field.id}-control_option-${option.id}`} key={option.id} value={option.value}>
          {option.label}
        </option>
      ))}
    </Select>
  );
};
